import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { CheckCircle, Loader2, Globe, RefreshCw } from "lucide-react";

export const EndpointUrlInput = ({
  value = "",
  onChange,
  error,
  loading = false,
  meta,
}) => {
  const [internalValue, setInternalValue] = useState(value);
  const isLoaded = meta && meta.title && !loading;

  const emitChange = () => {
    if (!internalValue.trim()) return;
    onChange({ target: { name: "endpointURL", value: internalValue } });
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      emitChange();
    }
  };

  return (
    <div className="space-y-4">
      <section>
        <div className="relative flex gap-3">
          <div className="relative flex-1">
            <Globe className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-400 w-5 h-5" />
            <input
              type="url"
              value={internalValue}
              onChange={(e) => setInternalValue(e.target.value)}
              onKeyDown={handleKeyDown}
              placeholder="https://..."
              disabled={loading}
              className={`w-full pl-12 pr-4 py-4 bg-white border-2 rounded-2xl outline-none transition-all font-medium
                ${error ? "border-red-500 bg-red-50" : "border-slate-100 focus:border-green-500 focus:ring-4 focus:ring-green-50"}
                ${loading ? "opacity-50 cursor-not-allowed" : "opacity-100"}
              `}
            />
          </div>
          <button
            type="button"
            onClick={emitChange}
            disabled={loading || !internalValue}
            className={`px-10 py-5 rounded-2xl font-black text-xs uppercase tracking-widest transition-all flex items-center gap-2 shadow-xl active:scale-95 disabled:opacity-50 disabled:cursor-not-allowed
              ${loading 
                ? "bg-slate-100 text-slate-400 shadow-none" 
                : "bg-green-50 text-green-700 hover:bg-green-600 hover:text-black hover:shadow-green-200"
              }
            `}
          >
            {loading ? (
              <>
                <Loader2 className="w-4 h-4 animate-spin" />
                Syncing...
              </>
            ) : isLoaded ? (
              <>
                <RefreshCw className="w-4 h-4" />
                Refetch
              </>
            ) : (
              "Fetch Metadata"
            )}
          </button>
        </div>
      </section>

      <AnimatePresence>
        {isLoaded && !loading && (
          <motion.div
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.95 }}
            className="flex items-center gap-2 text-green-600 bg-green-50 w-fit px-4 py-1.5 rounded-full border border-green-100"
          >
            <CheckCircle className="w-4 h-4" />
            <span className="text-xs font-bold uppercase tracking-widest">Metadata Loaded</span>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};